/**
 * Mapa de prefijos de códigos postales de México a coordenadas aproximadas
 * Los primeros 2 dígitos del CP identifican el estado/región
 * Fuente: SEPOMEX - Servicio Postal Mexicano
 */

export const cpCoordinates = {
  // CDMX (01-16)
  "01": { lat: 19.3594, lng: -99.2025, region: "Álvaro Obregón, CDMX" },
  "02": { lat: 19.4833, lng: -99.15, region: "Azcapotzalco, CDMX" },
  "03": { lat: 19.3722, lng: -99.1676, region: "Benito Juárez, CDMX" },
  "04": { lat: 19.3133, lng: -99.15, region: "Coyoacán, CDMX" },
  "05": { lat: 19.305, lng: -99.2478, region: "Cuajimalpa, CDMX" },
  "06": { lat: 19.4326, lng: -99.1332, region: "Cuauhtémoc, CDMX" },
  "07": { lat: 19.4833, lng: -99.1167, region: "Gustavo A. Madero, CDMX" },
  "08": { lat: 19.3577, lng: -99.0817, region: "Iztacalco, CDMX" },
  "09": { lat: 19.355, lng: -99.05, region: "Iztapalapa, CDMX" },
  10: { lat: 19.2967, lng: -99.2, region: "La Magdalena Contreras, CDMX" },
  11: { lat: 19.45, lng: -99.2, region: "Miguel Hidalgo, CDMX" },
  12: { lat: 19.25, lng: -99.1, region: "Milpa Alta, CDMX" },
  13: { lat: 19.2678, lng: -99.1378, region: "Tláhuac, CDMX" },
  14: { lat: 19.2867, lng: -99.17, region: "Tlalpan, CDMX" },
  15: { lat: 19.45, lng: -99.1167, region: "Venustiano Carranza, CDMX" },
  16: { lat: 19.2933, lng: -99.22, region: "Xochimilco, CDMX" },

  // Aguascalientes (20)
  20: { lat: 21.8818, lng: -102.2916, region: "Aguascalientes" },

  // Baja California (21-22)
  21: { lat: 32.5149, lng: -117.0382, region: "Tijuana, Baja California" },
  22: {
    lat: 31.8667,
    lng: -116.5964,
    region: "Ensenada/Mexicali, Baja California"
  },

  // Baja California Sur (23)
  23: { lat: 24.1426, lng: -110.3128, region: "Baja California Sur" },

  // Campeche (24)
  24: { lat: 19.8301, lng: -90.5349, region: "Campeche" },

  // Coahuila (25-27)
  25: { lat: 25.4232, lng: -101.0053, region: "Saltillo, Coahuila" },
  26: { lat: 26.9261, lng: -101.42, region: "Piedras Negras, Coahuila" },
  27: { lat: 25.5428, lng: -103.4068, region: "Torreón, Coahuila" },

  // Colima (28)
  28: { lat: 19.2452, lng: -103.7241, region: "Colima" },

  // Chiapas (29-30)
  29: { lat: 16.7569, lng: -93.1292, region: "Tuxtla Gutiérrez, Chiapas" },
  30: { lat: 16.25, lng: -92.1333, region: "San Cristóbal, Chiapas" },

  // Chihuahua (31-33)
  31: { lat: 28.6353, lng: -106.0889, region: "Chihuahua" },
  32: { lat: 31.7333, lng: -106.4833, region: "Ciudad Juárez, Chihuahua" },
  33: { lat: 28.4167, lng: -105.85, region: "Delicias/Cuauhtémoc, Chihuahua" },

  // Durango (34-35)
  34: { lat: 24.0277, lng: -104.6532, region: "Durango" },
  35: { lat: 25.55, lng: -103.5, region: "Gómez Palacio, Durango" },

  // Guanajuato (36-38)
  36: { lat: 21.019, lng: -101.2574, region: "Guanajuato" },
  37: { lat: 20.6767, lng: -101.3542, region: "León, Guanajuato" },
  38: { lat: 20.5333, lng: -100.8167, region: "Celaya/Irapuato, Guanajuato" },

  // Guerrero (39-41)
  39: { lat: 16.8634, lng: -99.8825, region: "Acapulco, Guerrero" },
  40: { lat: 17.55, lng: -99.5, region: "Chilpancingo, Guerrero" },
  41: { lat: 17.6614, lng: -101.5522, region: "Zihuatanejo, Guerrero" },

  // Hidalgo (42-43)
  42: { lat: 20.1011, lng: -98.7591, region: "Pachuca, Hidalgo" },
  43: { lat: 20.4167, lng: -98.9833, region: "Tula/Tulancingo, Hidalgo" },

  // Jalisco (44-49)
  44: { lat: 20.6767, lng: -103.3475, region: "Guadalajara Centro, Jalisco" },
  45: {
    lat: 20.7214,
    lng: -103.3833,
    region: "Guadalajara Norte/Zapopan, Jalisco"
  },
  46: { lat: 20.75, lng: -103.25, region: "Guadalajara Tonalá, Jalisco" },
  47: { lat: 21.1561, lng: -104.5, region: "Lagos de Moreno, Jalisco" },
  48: { lat: 20.6667, lng: -105.2333, region: "Puerto Vallarta, Jalisco" },
  49: { lat: 19.7, lng: -103.4667, region: "Ciudad Guzmán, Jalisco" },

  // Estado de México (50-57)
  50: { lat: 19.2826, lng: -99.6556, region: "Toluca, Estado de México" },
  51: {
    lat: 19.1833,
    lng: -99.4333,
    region: "Valle de Bravo, Estado de México"
  },
  52: {
    lat: 19.5438,
    lng: -99.2108,
    region: "Tlalnepantla/Atizapán, Estado de México"
  },
  53: { lat: 19.4969, lng: -99.2328, region: "Naucalpan, Estado de México" },
  54: {
    lat: 19.6727,
    lng: -99.2068,
    region: "Cuautitlán Izcalli, Estado de México"
  },
  55: { lat: 19.601, lng: -99.06, region: "Ecatepec, Estado de México" },
  56: { lat: 19.29, lng: -98.88, region: "Chalco/Amecameca, Estado de México" },
  57: {
    lat: 19.4167,
    lng: -99.0667,
    region: "Nezahualcóyotl, Estado de México"
  },

  // Michoacán (58-61)
  58: { lat: 19.706, lng: -101.195, region: "Morelia, Michoacán" },
  59: { lat: 19.9167, lng: -102.05, region: "Zamora, Michoacán" },
  60: { lat: 19.0833, lng: -102.2833, region: "Uruapan, Michoacán" },
  61: { lat: 18.9167, lng: -103.8833, region: "Lázaro Cárdenas, Michoacán" },

  // Morelos (62)
  62: { lat: 18.9242, lng: -99.2216, region: "Cuernavaca, Morelos" },

  // Nayarit (63)
  63: { lat: 21.5039, lng: -104.8946, region: "Tepic, Nayarit" },

  // Nuevo León (64-67)
  64: { lat: 25.6714, lng: -100.3089, region: "Monterrey Centro, Nuevo León" },
  65: { lat: 25.75, lng: -100.3, region: "Monterrey Norte, Nuevo León" },
  66: {
    lat: 25.6833,
    lng: -100.3167,
    region: "San Pedro/San Nicolás, Nuevo León"
  },
  67: { lat: 25.45, lng: -100.0, region: "Monterrey Sur, Nuevo León" },

  // Oaxaca (68-71)
  68: { lat: 17.0732, lng: -96.7266, region: "Oaxaca de Juárez" },
  69: { lat: 16.8833, lng: -96.7167, region: "Oaxaca Sur" },
  70: { lat: 16.4167, lng: -95.2, region: "Juchitán/Salina Cruz, Oaxaca" },
  71: { lat: 18.0833, lng: -96.1333, region: "Tuxtepec, Oaxaca" },

  // Puebla (72-75)
  72: { lat: 19.0414, lng: -98.2063, region: "Puebla Centro" },
  73: { lat: 18.9, lng: -98.65, region: "Atlixco, Puebla" },
  74: { lat: 18.4667, lng: -97.3833, region: "Tehuacán, Puebla" },
  75: { lat: 20.0333, lng: -97.85, region: "Teziutlán, Puebla" },

  // Querétaro (76)
  76: { lat: 20.5881, lng: -100.3899, region: "Querétaro" },

  // Quintana Roo (77)
  77: { lat: 21.1619, lng: -86.8515, region: "Cancún, Quintana Roo" },

  // San Luis Potosí (78-79)
  78: { lat: 22.1565, lng: -100.9855, region: "San Luis Potosí" },
  79: { lat: 22.0833, lng: -100.8333, region: "Soledad/Matehuala, SLP" },

  // Sinaloa (80-82)
  80: { lat: 24.8049, lng: -107.394, region: "Culiacán, Sinaloa" },
  81: { lat: 25.7903, lng: -108.9856, region: "Los Mochis, Sinaloa" },
  82: { lat: 23.2494, lng: -106.4111, region: "Mazatlán, Sinaloa" },

  // Sonora (83-85)
  83: { lat: 29.0729, lng: -110.9559, region: "Hermosillo, Sonora" },
  84: { lat: 31.3167, lng: -110.95, region: "Nogales, Sonora" },
  85: { lat: 27.4833, lng: -109.9333, region: "Ciudad Obregón, Sonora" },

  // Tabasco (86)
  86: { lat: 17.9892, lng: -92.9475, region: "Villahermosa, Tabasco" },

  // Tamaulipas (87-89)
  87: { lat: 23.7369, lng: -99.1411, region: "Ciudad Victoria, Tamaulipas" },
  88: { lat: 25.8796, lng: -97.5039, region: "Reynosa/Matamoros, Tamaulipas" },
  89: { lat: 22.2331, lng: -97.8619, region: "Tampico, Tamaulipas" },

  // Tlaxcala (90)
  90: { lat: 19.3139, lng: -98.2404, region: "Tlaxcala" },

  // Veracruz (91-96)
  91: { lat: 19.1738, lng: -96.1342, region: "Xalapa, Veracruz" },
  92: {
    lat: 18.15,
    lng: -94.4333,
    region: "Coatzacoalcos/Minatitlán, Veracruz"
  },
  93: { lat: 20.9667, lng: -97.4, region: "Poza Rica, Veracruz" },
  94: { lat: 18.85, lng: -97.1, region: "Córdoba/Orizaba, Veracruz" },
  95: { lat: 17.9333, lng: -94.9167, region: "Acayucan, Veracruz" },
  96: { lat: 19.2, lng: -96.1333, region: "Veracruz Puerto" },

  // Yucatán (97)
  97: { lat: 20.9674, lng: -89.5926, region: "Mérida, Yucatán" },

  // Zacatecas (98-99)
  98: { lat: 22.7709, lng: -102.5833, region: "Zacatecas" },
  99: { lat: 22.4833, lng: -102.7667, region: "Fresnillo, Zacatecas" }
};

/**
 * Obtiene las coordenadas aproximadas de un código postal
 * @param {string} cp - Código postal de 5 dígitos
 * @returns {{ lat: number, lng: number, region: string } | null}
 */
export const getCoordinatesFromCP = (cp) => {
  if (!cp || cp.length < 2) return null;

  const prefix = cp.substring(0, 2);
  return cpCoordinates[prefix] || null;
};

/**
 * Coordenadas por defecto (Centro de CDMX)
 */
export const DEFAULT_COORDS = {
  lat: 19.4326,
  lng: -99.1332,
  region: "Centro de México"
};
